module.exports = __webpack_public_path__ + "img/canvasMenuStart.b3142240.svg";